export default __webpack_public_path__ + "static/media/product_10.f239e11c.png";